import { getAgentsApiBaseUrl } from '@saaga/shared/store/agents-api.store'
import {
  getAuthToken,
  getPlan,
  getTenantId,
  getUserId,
} from '@saaga/shared/store/token-provider.store'

const buildAuthHeaders = async (): Promise<Record<string, string>> => {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  const token = await getAuthToken()
  if (token) headers.Authorization = `Bearer ${token}`
  const tenantId = getTenantId()
  if (tenantId) headers['x-tenant-id'] = tenantId
  const userId = getUserId()
  if (userId) headers['x-user-id'] = userId
  const plan = getPlan()
  if (plan) headers['x-plan'] = plan
  return headers
}

export const fetchReportPdfBlob = async (htmlContent: string): Promise<Blob> => {
  const headers = await buildAuthHeaders()
  const response = await fetch(`${getAgentsApiBaseUrl()}/api/v1/reports/render-pdf`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ html_content: htmlContent }),
  })
  if (!response.ok) {
    throw new Error(`PDF render failed (${response.status})`)
  }
  return response.blob()
}
